import {
    EMPTY_DECLINING_VALUE,
    EMPTY_MOVED_UP_VALUE,
} from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/constants";

import * as SC from "../BodyByState/styles";
import { MetricCardVariant } from "../BodyByState/types";
import { KEYWORDS_DECLINING, KEYWORDS_MOVED_UP } from "../BodyByState/texts";
import { MetricCard } from "./MetricCard";

export const RightAsideEmpty = () => {
    return (
        <SC.RightAsideCardsWrapper>
            <MetricCard
                value={EMPTY_MOVED_UP_VALUE}
                labelKey={KEYWORDS_MOVED_UP}
                variant={MetricCardVariant.Up}
                dataAutomation="share-data-rank-tracker-card-moved-up"
            />
            <MetricCard
                value={EMPTY_DECLINING_VALUE}
                labelKey={KEYWORDS_DECLINING}
                variant={MetricCardVariant.Declining}
                dataAutomation="share-data-rank-tracker-card-declining"
            />
        </SC.RightAsideCardsWrapper>
    );
};
